import './index.css';
import { useState, useEffect, useRef } from 'react';
import lefticon from '../../images/Leftnew.svg';
import img from '../../images/setup-logo.svg';

export default function SetupPage() {
    const [isOpen, setIsOpen] = useState(false);
    const dropdownRef = useRef(null);

    const toggleDropdown = (event) => {
        event.stopPropagation(); // Prevents event from bubbling up
        setIsOpen((prev) => !prev);
    };

    useEffect(() => {
        const handleClickOutside = (event) => {
            if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
                setIsOpen(false);
            }
        };
        document.addEventListener("click", handleClickOutside);
        return () => {
            document.removeEventListener("click", handleClickOutside);
        };
    }, []);

    return (
        <div className='Login-container-bg'>
            <div className='Login-container-main'>
                <div className='setup-container-main'>
                    <div className='setup-icon-container'>
                        <img src={lefticon} alt="Setup Icon" className='setup-icon' />
                    </div>
                    <div className='setup-logo-container'>
                        <img src={img} alt="Setup Logo" className='setup-logo' />
                    </div>
                    <h2 className='setup-title'>Setup Metabolytics</h2>
                    <p className='setup-description'>Metabolytics delivers AI-powered insights to help healthcare providers understand, monitor, and improve patient outcomes</p>
                    <h6 className='setup-steps-title'>Steps</h6>
                    <div className="setup-dropdown" ref={dropdownRef}>
                        <button className="setup-dropdown-btn" onClick={toggleDropdown}>
                            Profile setup
                            <span className={`setup-arrow ${isOpen ? 'open' : ''}`}>
                                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                                    <path d="M19.9201 8.9502L13.4001 15.4702C12.6301 16.2402 11.3701 16.2402 10.6001 15.4702L4.08008 8.9502" stroke="#9EA3AE" strokeWidth="1.5" strokeMiterlimit="10" strokeLinecap="round" strokeLinejoin="round" />
                                </svg>
                            </span>
                        </button>
                        <div className={`setup-dropdown-content ${isOpen ? 'show' : ''}`}>
                            <a href="#" className='setup-dropdown-item'>Complete Profile</a>
                            <a href="#" className='setup-dropdown-item'>Update Information</a>
                            <a href="#" className='setup-dropdown-item'>Review Settings</a>
                        </div>
                    </div>
                    <div className='login-button-container setup-button'>
                        <button>
                            Lets go!
                        </button>
                    </div>
                </div>
            </div>
        </div>
    );
}
